import { createFileRoute, Outlet, Navigate } from '@tanstack/react-router';
import { useIsAdmin } from '@/hooks/useIsCompanyAdmin';

export const Route = createFileRoute('/_auth/operations')({
  component: AdminLayout,
});

function AdminLayout() {
  const { isAdmin, isLoaded } = useIsAdmin();

  // Non-admins get the crew experience on every platform now, so a straight
  // bounce to Home works on desktop web too.
  if (isLoaded && !isAdmin) {
    return <Navigate to="/home" />;
  }

  return <Outlet />;
}
